export default "__VITE_IMAGE_ASSET__810c0e48__";